// extracted by mini-css-extract-plugin
export default {"carouselCaption":"banner_carouselCaption__Rl+FR","spanText":"banner_spanText__Ef2iT"};